import { InputError } from '@foodsby/nutrient'
import { Button, TextField, Box } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import currency from 'currency.js'
import PropTypes from 'prop-types'
import React, { useEffect, useState } from 'react'
import { TextMaskDollaBills } from './InputMasks'

import { useStateValue } from '../../providers/ProviderCheckout'
import { pushSnowplow, toOrderProcessSchema } from '../../util/snowplow'
import { Submitting } from '../common/Submitting'

const useStyles = makeStyles(theme => ({
  inputRoot: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },
  applyButton: {
    borderBottomLeftRadius: 0,
    borderTopLeftRadius: 0,
    height: 40,
  },
}))

export const AddCredit = ({
  applyCredit,
  availableCredits,
  error,
  isAvailableCreditsLoading,
  isCheckoutCartLoading,
  isCreditApplying,
  setValue,
  value,
}) => {
  const [{ subscription }] = useStateValue()
  const classes = useStyles()

  useEffect(() => {
    error &&
      pushSnowplow(toOrderProcessSchema('daily', 'checkout_credit_amount_apply', null, error))
  }, [error])

  return (
    <Box display="flex" alignItems="flex-start">
      <TextField
        label="Credit Amount"
        fullWidth
        variant="outlined"
        color="secondary"
        size="small"
        id="credit"
        name="credit"
        InputProps={{
          classes: {
            root: classes.inputRoot,
          },
          inputComponent: TextMaskDollaBills,
        }}
        onBlur={evt =>
          pushSnowplow(
            toOrderProcessSchema('daily', 'checkout_credit_amount_enter', evt.target.value),
          )
        }
        onKeyDown={e => {
          if (e.keyCode === 13) {
            applyCredit(value, subscription.value)
            pushSnowplow(toOrderProcessSchema('daily', 'checkout_credit_amount_apply', value))
          }
        }}
        onChange={val => setValue(val)}
        value={value}
        error={!!error}
        helperText={
          error ||
          (!isAvailableCreditsLoading &&
            availableCredits &&
            `Total credits available: ${currency(availableCredits, {
              formatWithSymbol: true,
            }).format()}`)
        }
      />
      <Button
        variant="contained"
        disableElevation
        color="secondary"
        classes={{ root: classes.applyButton }}
        disabled={!value || isCheckoutCartLoading || isCreditApplying}
        onClick={event => {
          event.preventDefault()
          applyCredit(value, subscription.value)
          pushSnowplow(toOrderProcessSchema('daily', 'checkout_credit_amount_apply', value))
        }}
      >
        Apply
      </Button>
    </Box>
  )
}

export const RemoveAppliedCredit = ({
  applyCredit,
  availableCredits,
  creditsUsed,
  error,
  isAvailableCreditsLoading,
  isCreditApplying,
  setValue,
}) => {
  const [{ subscription }] = useStateValue()

  return (
    <div className="Input Input--attached">
      <label htmlFor="credit">Credits Applied</label>
      <div className="Input--attachedSet ">
        <p className="Input-mockInput">
          {currency(creditsUsed, { formatWithSymbol: true }).format()}
        </p>

        {isCreditApplying ? (
          <Submitting text="Changing" />
        ) : (
          <Button
            className="button secondary"
            onClick={() => {
              applyCredit(0, subscription.value)
              setValue(creditsUsed)
            }}
            type="button"
          >
            Change
          </Button>
        )}
      </div>
      {!isAvailableCreditsLoading && availableCredits ? (
        <label htmlFor="credit">
          Total credits available: {currency(availableCredits, { formatWithSymbol: true }).format()}
        </label>
      ) : null}
      <InputError className="Input-error">{error}</InputError>
    </div>
  )
}
export const Credit = ({
  applyCredit,
  availableCredits,
  creditsApplied,
  creditsUsed,
  error,
  isAvailableCreditsLoading,
  isCheckoutCartLoading,
  isCreditApplying,
  suggestedCredits,
}) => {
  const [value, setValue] = useState('')

  useEffect(() => {
    setValue(suggestedCredits)
  }, [suggestedCredits])

  return (
    <>
      {creditsApplied ? (
        <RemoveAppliedCredit
          applyCredit={applyCredit}
          availableCredits={availableCredits}
          creditsUsed={creditsUsed}
          error={error}
          isAvailableCreditsLoading={isAvailableCreditsLoading}
          isCheckoutCartLoading={isCheckoutCartLoading}
          isCreditApplying={isCreditApplying}
          setValue={setValue}
          value={value}
        />
      ) : (
        <AddCredit
          applyCredit={applyCredit}
          availableCredits={availableCredits}
          error={error}
          isAvailableCreditsLoading={isAvailableCreditsLoading}
          isCheckoutCartLoading={isCheckoutCartLoading}
          isCreditApplying={isCreditApplying}
          setValue={setValue}
          value={value}
        />
      )}
    </>
  )
}

Credit.propTypes = {
  applyCredit: PropTypes.func,
  availableCredits: PropTypes.number,
  creditsApplied: PropTypes.bool,
  creditsUsed: PropTypes.number,
  error: PropTypes.string,
  isAvailableCreditsLoading: PropTypes.bool,
  isCheckoutCartLoading: PropTypes.bool,
  isCreditApplying: PropTypes.bool,
  suggestedCredits: PropTypes.number,
}

export default Credit
